/**
 * Elements with data-open-search-dialog attribute will open the dialog on click
 * Elements with data-close-search-dialog attribute will close the dialog on click
 *
 * To open the dialog via JS, trigger a custom event "open-search-dialog"
 * To close the dialog via JS, trigger a custom event "close-search-dialog"
 */
class SearchDialog {
  #dialog;

  constructor() {
    this.#dialog = document.getElementById("search-dialog");
  }

  initialize() {
    if (!this.#dialog) {
      console.error(`Search dialog element not found`);
      return;
    }

    this.#registerEvents();
  }

  #openDialog() {
    this.#dialog.showModal();
  }

  #closeDialog() {
    this.#dialog.close();
  }

  #handleDocumentClick(event) {
    if (event.target.hasAttribute("data-open-search-dialog")) {
      event.preventDefault();
      this.#openDialog();
      return;
    }

    if (event.target.hasAttribute("data-close-search-dialog")) {
      event.preventDefault();
      this.#closeDialog();
      return;
    }

    // Close on backdrop click
    if (event.target.nodeName === "DIALOG" && event.target === this.#dialog) {
      this.#closeDialog();
      return;
    }
  }

  #registerEvents() {
    const clickHandler = this.#handleDocumentClick.bind(this);
    const openDialogHandler = this.#openDialog.bind(this);
    const closeDialogHandler = this.#closeDialog.bind(this);

    document.addEventListener("click", clickHandler);
    document.addEventListener("open-search-dialog", openDialogHandler);
    document.addEventListener("close-search-dialog", closeDialogHandler);
  }
}

const searchDialog = new SearchDialog();
searchDialog.initialize();
